import { LimitedAccountPopup } from "Components/Dashboard/LimitedAccountPopup";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { MerchantPaymentInitiator } from "Components/Merchant/Initiate/MerchantPaymentInitiator";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useSearchParams } from "Navigation/useSearchParams";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

export const MerchantInitiatePaymentPage = () => {
  const [searchParams] = useSearchParams();
  const { t } = useResource();

  const bankAccountPublicID = searchParams.get("publicID") ?? undefined;

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.MerchantInitiatePayment)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
      isBottomMenuHidden
    >
      <StyledPageWrapper>
        <MerchantPaymentInitiator
          variant="form"
          bankAccountPublicID={bankAccountPublicID}
        />
        <LimitedAccountPopup />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantInitiatePaymentPage;
